<div class="aca-ver">
  <!-- ── the history itself ──────────────────────────────────────────────── -->
  <div class="aca-ver__main">
    <div class="aca-ver__addrow">
      <button type="button" class="aca-ver__primary" [disabled]="busy()" (click)="picker.click()">
        <mat-icon>add</mat-icon>{{ 'DMS.HISTORY.ADD_VERSION' | translate }}
      </button>
      <input #picker type="file" class="aca-ver__picker" (change)="chooseFile($event)" [attr.aria-label]="'DMS.HISTORY.ADD_VERSION' | translate" />
    </div>

    <!-- once a file is chosen, the note that goes with it is asked for here -->
    <section class="aca-ver__card aca-ver__upload" *ngIf="pendingFile() as file">
      <div class="aca-ver__uploadhead">
        <mat-icon>upload_file</mat-icon>
        <span class="aca-ver__uploadname">{{ file.name }}</span>
        <span class="aca-ver__uploadsize">{{ shortSize(file.size) }}</span>
      </div>
      <label class="aca-ver__field">
        <span class="aca-ver__label">{{ 'DMS.HISTORY.UPLOAD_COMMENT' | translate }}</span>
        <input class="aca-ver__input" [(ngModel)]="uploadComment" [placeholder]="'DMS.HISTORY.UPLOAD_COMMENT_PH' | translate" />
      </label>
      <label class="aca-ver__check">
        <input type="checkbox" [(ngModel)]="uploadMajor" />
        <span>{{ 'DMS.HISTORY.MAJOR' | translate }}</span>
      </label>
      <div class="aca-ver__uploadactions">
        <button type="button" class="aca-ver__outline" (click)="cancelUpload()">{{ 'DMS.UI.7D3094' | translate }}</button>
        <button type="button" class="aca-ver__primary" [disabled]="busy()" (click)="upload()">
          <mat-icon>cloud_upload</mat-icon>{{ 'DMS.HISTORY.UPLOAD' | translate }}
        </button>
      </div>
    </section>

    <!-- ── summary ───────────────────────────────────────────────────────── -->
    <dl class="aca-ver__summary">
      <div class="aca-ver__stat">
        <span class="aca-ver__stattile"><mat-icon>layers</mat-icon></span>
        <dt>{{ 'DMS.UI.0A2379' | translate }}</dt>
        <dd class="aca-ver__statvalue">{{ current() ? 'v' + current().id : '—' }}</dd>
      </div>
      <div class="aca-ver__stat">
        <span class="aca-ver__stattile"><mat-icon>schedule</mat-icon></span>
        <dt>{{ 'DMS.UI.7C6EDB' | translate }}</dt>
        <dd>{{ 'DMS.HISTORY.COUNT' | translate: { p0: versions().length } }}</dd>
      </div>
      <div class="aca-ver__stat">
        <span class="aca-ver__stattile"><mat-icon>event</mat-icon></span>
        <dt>{{ 'DMS.UI.8725DC' | translate }}</dt>
        <dd>{{ (current()?.modifiedAt | acaDate: 'd MMMM y HH:mm') || '—' }}</dd>
      </div>
      <div class="aca-ver__stat">
        <span class="aca-ver__stattile"><mat-icon>person</mat-icon></span>
        <dt>{{ 'DMS.UI.28F958' | translate }}</dt>
        <dd>{{ current()?.author || '—' }}</dd>
      </div>
    </dl>

    <mat-progress-bar mode="indeterminate" *ngIf="loading() || busy()" />

    <!-- ── the timeline ──────────────────────────────────────────────────── -->
    <section class="aca-ver__card">
      <div class="aca-ver__cardhead">
        <span class="aca-ver__headtile"><mat-icon>schedule</mat-icon></span>
        <span class="aca-ver__headtext">
          <h3 class="aca-ver__title">{{ 'DMS.UI.3A6843' | translate }}</h3>
          <span class="aca-ver__subtitle">{{ 'DMS.HISTORY.LIST_SUB' | translate }}</span>
        </span>
        <button type="button" class="aca-ver__outline" (click)="openCompare()">
          <mat-icon>balance</mat-icon>{{ 'DMS.HISTORY.COMPARE' | translate }}
        </button>
        <label class="aca-ver__filter">
          <mat-icon>filter_alt</mat-icon>
          <select [ngModel]="filter()" (ngModelChange)="setFilter($event)" [attr.aria-label]="'DMS.PERMISSIONS.FILTER' | translate">
            <option *ngFor="let entry of filters" [value]="entry.id">{{ entry.label | translate }}</option>
          </select>
          <mat-icon class="aca-ver__filterchevron">expand_more</mat-icon>
        </label>
      </div>

      <!-- the comparison, shown in place when one is asked for -->
      <div class="aca-ver__compare" *ngIf="comparing()">
        <div class="aca-ver__comparehead">
          <h4>{{ 'DMS.HISTORY.COMPARE_TITLE' | translate }}</h4>
          <button type="button" class="aca-ver__iconbtn" (click)="closeCompare()" [attr.aria-label]="'DMS.UI.7D3094' | translate">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <div class="aca-ver__comparepick">
          <label>
            <span>{{ 'DMS.HISTORY.COMPARE_A' | translate }}</span>
            <select [(ngModel)]="compareA" (ngModelChange)="pickCompare()">
              <option *ngFor="let version of versions()" [value]="version.id">v{{ version.id }}</option>
            </select>
          </label>
          <mat-icon>compare_arrows</mat-icon>
          <label>
            <span>{{ 'DMS.HISTORY.COMPARE_B' | translate }}</span>
            <select [(ngModel)]="compareB" (ngModelChange)="pickCompare()">
              <option *ngFor="let version of versions()" [value]="version.id">v{{ version.id }}</option>
            </select>
          </label>
        </div>

        <table class="aca-ver__comparetable" *ngIf="rowA() as a">
          <tbody *ngIf="rowB() as b">
            <tr [class.aca-ver__diff]="differs('sizeInBytes')">
              <th>{{ 'DMS.HISTORY.F_SIZE' | translate }}</th>
              <td>{{ shortSize(a.sizeInBytes) }}</td>
              <td>{{ shortSize(b.sizeInBytes) }}</td>
            </tr>
            <tr [class.aca-ver__diff]="differs('author')">
              <th>{{ 'DMS.HISTORY.F_BY' | translate }}</th>
              <td>{{ a.author }}</td>
              <td>{{ b.author }}</td>
            </tr>
            <tr>
              <th>{{ 'DMS.HISTORY.F_WHEN' | translate }}</th>
              <td>{{ a.modifiedAt | acaDate: 'd MMM y HH:mm' }}</td>
              <td>{{ b.modifiedAt | acaDate: 'd MMM y HH:mm' }}</td>
            </tr>
            <tr [class.aca-ver__diff]="differs('mimeType')">
              <th>{{ 'DMS.HISTORY.F_TYPE' | translate }}</th>
              <td>{{ typeName(a.mimeType) }}</td>
              <td>{{ typeName(b.mimeType) }}</td>
            </tr>
            <tr [class.aca-ver__diff]="differs('comment')">
              <th>{{ 'DMS.HISTORY.F_NOTE' | translate }}</th>
              <td>{{ a.comment || '—' }}</td>
              <td>{{ b.comment || '—' }}</td>
            </tr>
          </tbody>
        </table>

        <!-- what the words themselves changed, read by the AI only when asked -->
        <div class="aca-ver__ai" *ngIf="assistant.status()?.insights && rowA() && rowB() && compareA !== compareB">
          <p class="aca-ver__aitext" *ngIf="aiChanges()">{{ aiChanges() }}</p>
          <p class="aca-ver__aihint" *ngIf="aiBy()">{{ aiBy() }}</p>
          <button type="button" class="aca-ver__outline" [disabled]="aiBusy()" (click)="aiCompare()">
            <mat-icon>auto_awesome</mat-icon>{{ (aiBusy() ? 'DMS.ASSISTANT.COMPARE_BUSY' : 'DMS.ASSISTANT.COMPARE_BUTTON') | translate }}
          </button>
        </div>
      </div>

      <p class="aca-ver__empty" *ngIf="!loading() && !visible().length">{{ 'DMS.HISTORY.EMPTY' | translate }}</p>

      <ol class="aca-ver__timeline" *ngIf="visible().length">
        <li
          class="aca-ver__entry"
          *ngFor="let version of visible(); trackBy: trackById"
          [class.aca-ver__entry--on]="selected()?.id === version.id"
          [class.aca-ver__entry--current]="version.current"
        >
          <span class="aca-ver__dot"></span>

          <button type="button" class="aca-ver__body" (click)="select(version)">
            <span class="aca-ver__chips">
              <span class="aca-ver__chip aca-ver__chip--now" *ngIf="version.current">{{ 'DMS.HISTORY.CURRENT' | translate }}</span>
              <span class="aca-ver__chip aca-ver__chip--num">v{{ version.id }}</span>
            </span>

            <span class="aca-ver__lines">
              <span class="aca-ver__name">{{ version.name }}</span>

              <span class="aca-ver__facts">
                <span class="aca-ver__fact">
                  <mat-icon>event</mat-icon>
                  <span class="aca-ver__facttext">
                    <span class="aca-ver__factvalue">{{ version.modifiedAt | acaDate: 'd MMMM y HH:mm' }}</span>
                    <span class="aca-ver__factlabel">{{ 'DMS.HISTORY.F_UPDATED' | translate }}</span>
                  </span>
                </span>

                <span class="aca-ver__fact">
                  <mat-icon>description</mat-icon>
                  <span class="aca-ver__facttext">
                    <span class="aca-ver__factvalue">{{ shortSize(version.sizeInBytes) }}</span>
                    <span class="aca-ver__factlabel">{{ 'DMS.HISTORY.F_SIZE' | translate }}</span>
                  </span>
                </span>

                <span class="aca-ver__fact">
                  <mat-icon>person</mat-icon>
                  <span class="aca-ver__facttext">
                    <span class="aca-ver__factvalue">{{ version.author }}</span>
                    <span class="aca-ver__factlabel">{{ 'DMS.HISTORY.F_BY' | translate }}</span>
                  </span>
                </span>
              </span>

              <span class="aca-ver__note" *ngIf="version.comment">
                <mat-icon>chat_bubble_outline</mat-icon>{{ version.comment }}
                <span class="aca-ver__notetag" *ngIf="version.current">{{ 'DMS.HISTORY.CHANGE_NOTE' | translate }}</span>
              </span>
            </span>
          </button>

          <button
            type="button"
            class="aca-ver__iconbtn"
            [matMenuTriggerFor]="rowMenu"
            [attr.aria-label]="'DMS.UI.76A0B4' | translate"
            [matTooltip]="'DMS.UI.76A0B4' | translate"
          >
            <mat-icon>more_vert</mat-icon>
          </button>

          <mat-menu #rowMenu="matMenu">
            <button mat-menu-item (click)="download(version)"><mat-icon>download</mat-icon>{{ 'DMS.HISTORY.DOWNLOAD' | translate }}</button>
            <button mat-menu-item [disabled]="version.current || busy()" (click)="restore(version)">
              <mat-icon>restore</mat-icon>{{ 'DMS.HISTORY.RESTORE' | translate }}
            </button>
            <button mat-menu-item [disabled]="version.current || busy()" (click)="remove(version)">
              <mat-icon>delete_outline</mat-icon>{{ 'DMS.HISTORY.DELETE' | translate }}
            </button>
          </mat-menu>
        </li>
      </ol>

      <p class="aca-ver__foot" *ngIf="visible().length">
        {{ 'DMS.HISTORY.SHOWING' | translate: { p0: visible().length, p1: versions().length } }}
      </p>
    </section>
  </div>

  <!-- ── the version picked out ──────────────────────────────────────────── -->
  <aside class="aca-ver__side" *ngIf="selected() as version">
    <div class="aca-ver__cardhead">
      <span class="aca-ver__headtile"><mat-icon>description</mat-icon></span>
      <span class="aca-ver__headtext">
        <h3 class="aca-ver__title">{{ 'DMS.HISTORY.DETAIL_TITLE' | translate }}</h3>
        <span class="aca-ver__subtitle">{{ 'DMS.HISTORY.DETAIL_SUB' | translate }}</span>
      </span>
      <span class="aca-ver__chips">
        <span class="aca-ver__chip aca-ver__chip--now" *ngIf="version.current">{{ 'DMS.HISTORY.CURRENT' | translate }}</span>
        <span class="aca-ver__chip aca-ver__chip--num">v{{ version.id }}</span>
      </span>
    </div>

    <dl class="aca-ver__props">
      <dt><mat-icon>insert_drive_file</mat-icon>{{ 'DMS.HISTORY.F_NAME' | translate }}</dt>
      <dd>{{ version.name }}</dd>

      <dt><mat-icon>image</mat-icon>{{ 'DMS.HISTORY.F_TYPE' | translate }}</dt>
      <dd>{{ typeName(version.mimeType) }}</dd>

      <dt><mat-icon>chat_bubble_outline</mat-icon>{{ 'DMS.HISTORY.F_COMMENT' | translate }}</dt>
      <dd>
        {{ version.comment || '—' }}
        <span class="aca-ver__hint" *ngIf="!version.comment">{{ 'DMS.HISTORY.NO_COMMENT' | translate }}</span>
      </dd>

      <dt><mat-icon>folder_open</mat-icon>{{ 'DMS.HISTORY.F_WHERE' | translate }}</dt>
      <dd>
        <span class="aca-ver__where">
          <span *ngFor="let part of location(); let last = last">{{ part.name }}<span *ngIf="!last"> / </span></span>
        </span>
      </dd>

      <dt><mat-icon>person</mat-icon>{{ 'DMS.HISTORY.F_BY' | translate }}</dt>
      <dd>
        <span class="aca-ver__author"
          ><span class="aca-ver__avatar">{{ version.initial }}</span
          >{{ version.author }}</span
        >
      </dd>

      <dt><mat-icon>sell</mat-icon>{{ 'DMS.UI.792FF6' | translate }}</dt>
      <dd>
        <span class="aca-ver__tags">
          <span class="aca-ver__tag" *ngFor="let tag of tags()">{{ tag.tag }}</span>
          <input
            #tagInput
            class="aca-ver__taginput"
            *ngIf="addingTag()"
            [(ngModel)]="newTag"
            (keyup.enter)="addTag()"
            (blur)="addTag()"
            [placeholder]="'DMS.UI.6C89F3' | translate"
            [attr.aria-label]="'DMS.UI.6C89F3' | translate"
          />
          <button type="button" class="aca-ver__tagadd" *ngIf="!addingTag()" (click)="startTag()">
            <mat-icon>add</mat-icon>{{ 'DMS.HISTORY.ADD_TAG' | translate }}
          </button>
        </span>
      </dd>

      <dt><mat-icon>lock_open</mat-icon>{{ 'DMS.UI.FDF18F' | translate }}</dt>
      <dd>
        <button type="button" class="aca-ver__link" (click)="showPermissions.emit()">
          {{ 'DMS.HISTORY.SEE_RIGHTS' | translate }}<mat-icon>chevron_right</mat-icon>
        </button>
      </dd>
    </dl>

    <button type="button" class="aca-ver__primary aca-ver__wide" (click)="download(version)">
      <mat-icon>download</mat-icon>{{ 'DMS.HISTORY.DOWNLOAD_THIS' | translate }}
    </button>

    <label class="aca-ver__comparewith">
      <mat-icon>balance</mat-icon>
      <select [ngModel]="''" (ngModelChange)="compareWith($event)" [attr.aria-label]="'DMS.HISTORY.COMPARE_WITH' | translate">
        <option value="">{{ 'DMS.HISTORY.COMPARE_WITH' | translate }}</option>
        <option *ngFor="let other of versions()" [value]="other.id" [disabled]="other.id === version.id">v{{ other.id }}</option>
      </select>
      <mat-icon class="aca-ver__filterchevron">expand_more</mat-icon>
    </label>
  </aside>
</div>
